"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultReplaceAPI = exports.encodeReplaceRequest = void 0;
const big_js_1 = __importDefault(require("big.js"));
const utils_1 = require("../utils");
const fee_1 = require("./fee");
const transaction_1 = require("./transaction");
const __1 = require("..");
function encodeReplaceRequest(req, network) {
    let displayedBtcAddress = "Pending...";
    let displayedNewVaultAddress = "Pending...";
    displayedBtcAddress = utils_1.encodeBtcAddress(req.btc_address, network);
    displayedNewVaultAddress = req.new_vault.toHuman();
    return Object.assign(Object.assign({}, req), { btc_address: displayedBtcAddress, new_vault: displayedNewVaultAddress });
}
exports.encodeReplaceRequest = encodeReplaceRequest;
class DefaultReplaceAPI extends transaction_1.DefaultTransactionAPI {
    constructor(api, btcNetwork, electrsAPI, account) {
        super(api, account);
        this.electrsAPI = electrsAPI;
        this.btcNetwork = btcNetwork;
        this.feeAPI = new fee_1.DefaultFeeAPI(api);
    }
    /**
     * @param events The EventRecord array returned after sending a replace request transaction
     * @returns The id associated with the replace request. If the EventRecord array does not
     * contain replace request events, the function throws an error.
     */
    getRequestIdFromEvents(events) {
        for (const { event } of events) {
            if (this.api.events.replace.RequestReplace.is(event)) {
                const hash = this.api.createType("Hash", event.data[0]);
                return hash;
            }
        }
        throw new Error("Request transaction failed");
    }
    request(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const amountSat = this.api.createType("Wrapped", __1.btcToSat(amount.toString()));
            const griefingCollateralDot = yield this.getGriefingCollateral(amount);
            const griefingCollateralPlanck = utils_1.dotToPlanck(griefingCollateralDot.toString());
            const requestTx = this.api.tx.replace.requestReplace(amountSat, griefingCollateralPlanck);
            const result = yield this.sendLogged(requestTx, this.api.events.replace.RequestReplace);
            try {
                return this.getRequestIdFromEvents(result.events).toString();
            }
            catch (e) {
                return Promise.reject(e);
            }
        });
    }
    withdraw(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const amountSat = this.api.createType("Wrapped", __1.btcToSat(amount.toString()));
            const requestTx = this.api.tx.replace.withdrawReplace(amountSat);
            yield this.sendLogged(requestTx, this.api.events.replace.WithdrawReplace);
        });
    }
    accept(oldVault, amount, collateral, btcAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedBtcAddress = this.api.createType("BtcAddress", btcAddress);
            const amountSat = this.api.createType("Wrapped", __1.btcToSat(amount.toString()));
            const collateralPlanck = this.api.createType("Collateral", utils_1.dotToPlanck(collateral.toString()));
            const requestTx = this.api.tx.replace.acceptReplace(oldVault, amountSat, collateralPlanck, parsedBtcAddress);
            yield this.sendLogged(requestTx, this.api.events.replace.AcceptReplace);
        });
    }
    execute(requestId, btcTxId, merkleProof, rawTx) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedRequestId = this.api.createType("H256", "0x" + requestId);
            [merkleProof, rawTx] = yield __1.getTxProof(this.electrsAPI, btcTxId, merkleProof, rawTx);
            const requestTx = this.api.tx.replace.executeReplace(parsedRequestId, merkleProof, rawTx);
            yield this.sendLogged(requestTx, this.api.events.replace.ExecuteReplace);
        });
    }
    getBtcDustValue() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const dustSatoshi = yield this.api.query.replace.replaceBtcDustValue.at(head);
            return new big_js_1.default(utils_1.satToBTC(dustSatoshi.toString()));
        });
    }
    getGriefingCollateral(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const griefingCollateralRate = yield this.feeAPI.getReplaceGriefingCollateralRate();
            return yield this.feeAPI.getGriefingCollateral(amount, griefingCollateralRate);
        });
    }
    getReplacePeriod() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            return yield this.api.query.replace.replacePeriod.at(head);
        });
    }
    list() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const replaceRequests = yield this.api.query.replace.replaceRequests.entriesAt(head);
            return replaceRequests
                .map((v) => encodeReplaceRequest(v[1], this.btcNetwork));
        });
    }
    map() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const redeemRequests = yield this.api.query.replace.replaceRequests.entriesAt(head);
            const redeemRequestMap = new Map();
            redeemRequests
                .forEach((v) => {
                redeemRequestMap.set(utils_1.storageKeyToFirstInner(v[0]), encodeReplaceRequest(v[1], this.btcNetwork));
            });
            return redeemRequestMap;
        });
    }
}
exports.DefaultReplaceAPI = DefaultReplaceAPI;
//# sourceMappingURL=replace.js.map